import { createAsyncThunk } from '@reduxjs/toolkit';
import { capitalize } from '@/libs/helpers';
import { validateName } from '@/libs/validation/validateName';
import { formsActions } from './index';
export const setPassengerName = createAsyncThunk('', async ({ _uuid, field, value }, thunkApi) => {
    const transformedValue = capitalize(value);
    const { error } = validateName(transformedValue);
    thunkApi.dispatch(formsActions._setPassengerField({
        _uuid,
        field,
        value: transformedValue,
    }));
    thunkApi.dispatch(formsActions._setPassengerFieldError({ _uuid, field, error }));
});
